class CartNotification extends HTMLElement {
  product = undefined;
  cartData = undefined;
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.productInfo = document.querySelector('product-info');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.querySelectorAll('[data-type="add-to-cart-form"]').forEach((entry) => {
      entry.addEventListener('submit', (event) => {
        event.preventDefault();
        const replaceProducts = JSON.parse(entry.querySelector('[name="replace-products"]')?.value || '[]');
        const formData = new FormData(entry);
        const formObject = Object.fromEntries(formData.entries());
        console.log(formObject)
        console.log(replaceProducts)
        
        const updates = {};
        const items = [];
        const replaceItems = this.product && this.cartData && this.product.properties['_Group Identify'] ? this.cartData.items.filter((item) => {
          if (item.properties && item.properties['_Group Identify'] && item.properties['_Group Identify'] === this.product.properties['_Group Identify']) {
            if (replaceProducts.includes(item.product_id)) {
              return true;
            }
          }
          return false;
        }) : [];

        const properties = Object.fromEntries(Object.entries(formObject).filter(([key, value]) => {
          return key.startsWith('properties');
        }).map(([key, value]) => {
          return [key.replace('properties[', '').replace(']', ''), value]
        }));
        properties['_Added From'] = 'UPSELL FORM';

        if (replaceItems.length > 0) {
          replaceItems.forEach((item) => {
            updates[item.key] = 0; // Remove old
            items.push({
              id: formObject.id,
              quantity: item.quantity,
              properties: Object.assign({}, item.properties, properties),
            });
          });
        } else {
          items.push({
            id: formObject.id,
            quantity: 1,
            properties
          })
        }

        const callUpdate = () => {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
        }

        const callAdd = () => {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          })
        }

        if (Object.keys(updates).length > 0) {
          callUpdate().finally(() => {
            callAdd().finally(() => {
              window.location = '/cart';
            })
          })
        } else {
          callAdd().finally(() => {
            window.location = '/cart';
          })
        }
      })
    })
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || !event.cartData) {
        return;
      }
      if (!this.notification || !this.notification.classList.contains('active')) {
        return;
      }
      this.updatePreviewFromCart(event.cartData);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    window.location.reload();
  }

  updatePreviewFromCart(cartData) {
    if (!this.cartItemKey || !cartData.items) {
      return;
    }
    const item = cartData.items.find((entry) => entry.key === this.cartItemKey);
    if (!item || !item.properties) {
      return;
    }
    const previewThumb = item.properties['_preview_image_thumbnail_url'] || item.properties['_preview_image_url'];
    if (!previewThumb) {
      return;
    }
    const image = this.querySelector(
      `#cart-notification-product-${this.cartItemKey} .cart-notification-product__image img`
    );
    if (!image) {
      return;
    }
    if (image.getAttribute('src') === previewThumb) {
      return;
    }
    image.removeAttribute('srcset');
    image.setAttribute('src', previewThumb);
    const altText = item.product_title || item.title;
    if (altText) {
      image.setAttribute('alt', altText);
    }
  }

  renderContents(parsedState, cartData) {
    this.product = parsedState;
    this.cartData = cartData;
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.renderAdditionalContent(parsedState, cartData);
    if (this.header) this.header.reveal();
    this.open();
  }

  getItemProperties(selectedProduct, cartData) {
    const properties = {};
    const groupIdentify = selectedProduct?.properties?.['_Group Identify'];
    if (!groupIdentify || !cartData?.items?.length) {
      return properties;
    }

    const groupedItems = cartData.items.filter((item) => item?.properties?.['_Group Identify'] === groupIdentify);
    if (groupedItems.length === 0) {
      return properties;
    }

    const product =
      groupedItems.find((item) => item.key === selectedProduct.key) ||
      groupedItems.find((item) => item.id === selectedProduct.id) ||
      groupedItems[0];

    if (product.properties) {
      Object.entries(product.properties).forEach(([key, value]) => {
        properties[key] = value;
      })
    }

    properties['title'] = [product.title];
    properties['sku'] = [];
    if (product.sku) {
      properties['sku'].push(product.sku);
    }

    if (groupIdentify) {
      groupedItems.filter((item) => item.key !== product.key).map((item) => {
        properties['title'].push(item.title)
        if (item.sku) {
          properties['sku'].push(item.sku);
        }
        Object.entries(item.properties || {}).forEach(([key, value]) => {
          properties[key] = value;
        })
      })
    }

    return properties;
  }

  renderAdditionalContent(product, cartData) {
    console.group();
    let additionalChoice = false;
    let defaultAdditional = null;

    const properties = this.getItemProperties(product, cartData);
    console.log(properties)
    const options = this.getProductOptions();
    this.querySelectorAll('.additional').forEach((additional) => {
      const property = additional.dataset.property;
      const propertyValue = additional.dataset.propertyValue;
      additional.style.display = 'none';
      switch (property) {
        case "title":
          if (this.matchesConfiguredValue(properties['title'], propertyValue) && !additionalChoice) {
            additionalChoice = true;
            additional.removeAttribute('style');
          }
          break;

        default:
          if (
            property &&
            (
              this.matchesConfiguredValue(properties[property], propertyValue) ||
              this.matchesTranslatedNoBaseRule(property, propertyValue, properties, options)
            ) &&
            !additionalChoice
          ) {
            additionalChoice = true;
            additional.removeAttribute('style');
          } else if (this.matchesConfiguredValue(options[property], propertyValue) && !additionalChoice) {
            additionalChoice = true;
            additional.removeAttribute('style');
          }
          break;
      }

      if (!property) {
        defaultAdditional = additional;
      }

      // additional.style.display = 'none'; // Default hide!
      // if (property.length > 0) {
      //   if (property in options && options[property] === propertyValue) {
      //     if (!additionalChoice) {
      //       additionalChoice = true;
      //       additional.removeAttribute('style');
      //     }
      //   }
      // } else {
      //   defaultAdditional = additional;
      // }
    })

    if (this.productInfo) {
      this.querySelectorAll('.additional form[data-type="add-to-cart-form"]').forEach((form) => {
        form.querySelector('[name="properties[_Group Identify]"]')?.remove();
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'properties[_Group Identify]')
        input.value = this.productInfo.groupIdentify;
        form.prepend(input)
      })
    }

    if (!additionalChoice && defaultAdditional) {
      defaultAdditional.removeAttribute('style');
    }
    console.groupEnd();
  }

  matchesConfiguredValue(actualValue, configuredValue) {
    if (actualValue === undefined || actualValue === null || configuredValue === undefined || configuredValue === null) {
      return false;
    }

    const expectedValues = String(configuredValue)
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

    if (expectedValues.length === 0) {
      return false;
    }

    if (Array.isArray(actualValue)) {
      return actualValue.some((value) => this.matchesConfiguredValue(value, configuredValue));
    }

    const normalizedActualValue = String(actualValue).trim().toLowerCase();
    return expectedValues.some((value) => normalizedActualValue === value.toLowerCase());
  }

  matchesTranslatedNoBaseRule(property, propertyValue, properties, options) {
    if (property !== 'sku') {
      return false;
    }

    const translatedNoBaseValues = ['No Light Base', '받침대 없음', '라이트 베이스 없음'];
    if (!this.matchesConfiguredValue(translatedNoBaseValues, propertyValue)) {
      return false;
    }

    return this.hasNoBaseSelection(properties, options);
  }

  hasNoBaseSelection(properties, options) {
    const noBaseSignals = ['LBNO0000', 'No Light Base', '받침대 없음', '라이트 베이스 없음'];
    const noBaseSignalValues = noBaseSignals.join(',');

    if (this.matchesConfiguredValue(properties['sku'], 'LBNO0000')) {
      return true;
    }

    if (this.matchesConfiguredValue(properties['title'], noBaseSignalValues)) {
      return true;
    }

    return Object.values(options).some((value) => this.matchesConfiguredValue(value, noBaseSignalValues));
  }

  getProductOptions() {
    return Object.fromEntries(
      Array.from(this.querySelectorAll('.cart-notification-product .product-option')).map((option) => {
        return [
          option.querySelector('dt')?.innerText?.replace(':', '')?.trim(), 
          option.querySelector('dd')?.innerText?.trim()
        ];
      }).filter((option) => option[0] && option[1])
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      // {
      //   id: 'cart-icon-bubble',
      // },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
